<template>
  <div class="relative inline-block" v-click-outside="() => (isDropdownOpen = false)">
    <div
      @click="isDropdownOpen = !isDropdownOpen"
      :class="showBackground === true ? 'hover:bg-gray-100' : ''"
      class="px-4 py-2 -mx-4 -my-2 rounded-md transition-colors duration-100 ease-in-out"
    >
      <slot>
        <base-button :color="color" :type="type">{{ label }}</base-button>
      </slot>
    </div>
    <transition
      enter-active-class="transition ease-out duration-100"
      enter-from-class="transform opacity-0 scale-95"
      enter-to-class="transform opacity-100 scale-100"
      leave-active-class="transition ease-in duration-75"
      leave-from-class="transform opacity-100 scale-100"
      leave-to-class="transform opacity-0 scale-95"
    >
      <div
        v-show="isDropdownOpen"
        :class="`origin-top-${align} absolute ${align}-0 mt-2 w-${width} rounded shadow-lg z-40 ring-0 ring-black ring-opacity-5 max-h-96 overflow-auto`"
      >
        <div class="py-1 rounded bg-white shadow-xs text-base font-normal">
          <div
            class="text-gray-600 hover:bg-gray-100 cursor-pointer text-sm"
            v-for="option in options"
            @click="option.onClick && option.onClick(), (isDropdownOpen = false)"
            :key="option.label"
          >
            <slot name="option" v-bind:option="option">
              <div class="py-2 px-4">{{ option.label }}</div>
            </slot>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    label: String,
    options: {
      type: Array,
      required: true,
    },
    type: String,
    color: String,
    align: {
      type: String,
      default: "left",
    },
    showBackground: { type: Boolean, default: true },
    width: {
      type: String,
      default: "48",
    },
  },
  data() {
    return {
      isDropdownOpen: false,
    };
  },
};
</script>
